<template>
  <el-calendar
    class="er-calendar"
    :data-header-visibilty="showHeader? 'show':'hide'"
    :range="inputRange"
  ></el-calendar>
</template>

<script>
export default {
  props: {
    showHeader: {
      default: true
    },
    inputRange: {
      default: () => [new Date(), new Date()]
    },
    selectedValues: {}
  },
  data: function() {
    return {
      value: 0
    };
  },
  method: {}
};
</script>

<style lang="scss">
.er-calendar {
  width: 250px;
  .el-calendar__header {
    .el-calendar__button-group {
      display: none;
    }
  }
  &[data-header-visibilty*="hide"] {
    .el-calendar__header {
      display: none;
    }
  }
  .el-calendar-table {
    // width: 250px;
    .el-calendar-day {
      height: 30px;
    }
  }
}
</style>
